import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqs } from "@/data/siteContent";
import { Reveal } from "@/components/Reveal";
import { ShieldCheck } from "lucide-react";
import { FAQS } from "@/constants/testIds";

export const FaqSection = () => {
  return (
    <section id="faq" data-testid={FAQS.section} className="py-16 sm:py-24 section-tint border-y border-border">
      <div className="container-x grid lg:grid-cols-3 gap-10">
        <Reveal className="lg:col-span-1">
          <p className="text-sm font-semibold text-accent uppercase tracking-wider">FAQ</p>
          <h2 className="mt-2 text-3xl sm:text-4xl font-semibold tracking-tight">Domande frequenti</h2>
          <p className="mt-4 text-muted-foreground text-base leading-relaxed">
            Tutto quello che devi sapere prima di acquistare. Hai altri dubbi? Scrivici nella sezione contatti.
          </p>
          <div className="mt-6 flex items-start gap-3 rounded-2xl border border-border bg-card p-4 glow">
            <ShieldCheck className="h-5 w-5 text-accent shrink-0 mt-0.5" />
            <p className="text-xs text-muted-foreground leading-relaxed">
              Il servizio va utilizzato solo nel rispetto della legge: su dispositivi propri o con il consenso dell'utilizzatore.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.08} className="lg:col-span-2">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-border">
                <AccordionTrigger className="text-left text-base font-medium hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="text-sm text-muted-foreground leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
